<div class="detail-container">
  <div class="header-section">
    <div class="title-group">
      <h1>{{ data.name }}</h1>
      <div class="info-line">
        <div class="info-item">
          <mat-icon>signpost</mat-icon>
          <span>{{ data.autobahn }}</span>
        </div>
        <div class="info-item">
          <mat-icon>pin_drop</mat-icon>
          <span>{{ data.lat.toFixed(5) }} - {{ data.lng.toFixed(5) }}</span>
        </div>
      </div>
    </div>
    <div class="actions-group">
      <a [href]="mapsHref" target="_blank" rel="noopener noreferrer">
        <button mat-icon-button aria-label="Route berechnen">
          <mat-icon>directions_walk</mat-icon>
        </button>
      </a>
      <button
        mat-icon-button
        aria-label="Zu Favoriten hinzufügen"
        color="accent"
        (click)="favoritesService.toggleFavorite(data.id)"
      >
        <mat-icon>{{ (isFavorite$ | async) ? 'favorite' : 'favorite_border' }}</mat-icon>
      </button>
    </div>
  </div>

  <div class="rating-section">
    <span>Bewertung: {{ data.averageRating.toFixed(1) }}</span>
    <div class="stars">
      @for (star of getStarArray(data.averageRating); track $index) {
        <mat-icon class="star-icon">{{ star }}</mat-icon>
      }
    </div>
  </div>
  <mat-divider></mat-divider>
  <app-rest-stop-photos [data]="data"></app-rest-stop-photos>

  <mat-divider></mat-divider>
  <mat-tab-group class="no-tab-pagination" dynamicHeight>
    <mat-tab label="Bewertungen">
      <div class="tab-body">
        <app-review-section [restStopId]="data.id" [restStop]="data" [showHeader]="false"></app-review-section>
      </div>
    </mat-tab>
    <mat-tab label="Ausstattung">
      <div class="tab-body">
        <section class="features-section">
          <div class="features-grid">
            <div class="feature-item" *ngFor="let feature of allAvailableFeatures">
              <mat-icon>{{ feature.icon }}</mat-icon>
              <span>{{ feature.label }}</span>
            </div>
          </div>
        </section>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
